import {
  queryPaymentLinkPayments as publicQueryPaymentLinkPayments,
  typedQueryPaymentLinkPayments as publicTypedQueryPaymentLinkPayments,
  searchPaymentLinkPayments as publicSearchPaymentLinkPayments,
  issueReceipt as publicIssueReceipt,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PaymentLinkPaymentQuery,
  PaymentLinkPaymentsQueryBuilder,
  typedQueryPaymentLinkPayments as universalTypedQueryPaymentLinkPayments,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';
import { onPaymentLinkPaymentCreated as publicOnPaymentLinkPaymentCreated } from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.public.js';
import { onPaymentLinkPaymentUpdated as publicOnPaymentLinkPaymentUpdated } from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.public.js';

function customQueryPaymentLinkPayments(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPaymentLinkPayments(httpClient)(),
    typedQueryFunction: (query: PaymentLinkPaymentQuery) =>
      publicTypedQueryPaymentLinkPayments(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PaymentLinkPaymentsQueryBuilder;
  function overloadedQuery(
    query: PaymentLinkPaymentQuery
  ): ReturnType<typeof universalTypedQueryPaymentLinkPayments>;
  function overloadedQuery(query?: PaymentLinkPaymentQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const searchPaymentLinkPayments: MaybeContext<
  BuildRESTFunction<typeof publicSearchPaymentLinkPayments> &
    typeof publicSearchPaymentLinkPayments
> = /*#__PURE__*/ createRESTModule(publicSearchPaymentLinkPayments);
export const issueReceipt: MaybeContext<
  BuildRESTFunction<typeof publicIssueReceipt> & typeof publicIssueReceipt
> = /*#__PURE__*/ createRESTModule(publicIssueReceipt);
export const queryPaymentLinkPayments: MaybeContext<
  BuildRESTFunction<typeof customQueryPaymentLinkPayments> &
    typeof customQueryPaymentLinkPayments
> = /*#__PURE__*/ createRESTModule(customQueryPaymentLinkPayments);
/**
 * Triggered when a payment link payment is created.
 */
export const onPaymentLinkPaymentCreated: BuildEventDefinition<
  typeof publicOnPaymentLinkPaymentCreated
> &
  typeof publicOnPaymentLinkPaymentCreated = /*#__PURE__*/ createEventModule(
  publicOnPaymentLinkPaymentCreated
);
/**
 * Triggered when a payment link payment is updated.
 */
export const onPaymentLinkPaymentUpdated: BuildEventDefinition<
  typeof publicOnPaymentLinkPaymentUpdated
> &
  typeof publicOnPaymentLinkPaymentUpdated = /*#__PURE__*/ createEventModule(
  publicOnPaymentLinkPaymentUpdated
);

export {
  PaymentLinkPaymentType,
  VatType,
  SubdivisionType,
  PaymentMethod,
  OrderType,
  WebhookIdentityType,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';
export {
  PaymentLinkPayment,
  PaymentLinkPaymentPaymentOneOf,
  PaymentLinkPaymentEcomCheckoutTypeOneOf,
  PaymentLinkPaymentCheckoutTypeOneOf,
  RegularPaymentLinkPayment,
  RegularPaymentLinkPaymentPaymentMethodDataOneOf,
  FullAddressContactDetails,
  VatId,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  CreditCardPaymentMethodData,
  WalletPaymentMethodData,
  PaymentOrder,
  PaymentOrderTypeDetailsOneOf,
  Ecom,
  Cashier,
  GiftCardPaymentLinkPayment,
  StandardCheckout,
  LeanCheckout,
  ExtendedFields,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  EcomCheckout,
  EcomOrderCheckout,
  QueryPaymentLinkPaymentsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPaymentLinkPaymentsResponse,
  CursorPagingMetadata,
  Cursors,
  SearchPaymentLinkPaymentsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  SearchPaymentLinkPaymentsResponse,
  PagingMetadataV2,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  IssueReceiptRequest,
  IssueReceiptResponse,
  BulkUpsertPaymentLinkPaymentsRequest,
  BulkUpsertPaymentLinkPaymentsResponse,
  Empty,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  PaymentLinkPaymentCreatedEnvelope,
  PaymentLinkPaymentUpdatedEnvelope,
  PaymentLinkPaymentsQueryResult,
  PaymentLinkPaymentsQueryBuilder,
  PaymentLinkPaymentQuerySpec,
  PaymentLinkPaymentSearchSpec,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';
export { utils } from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';
export {
  PaymentLinkPaymentTypeWithLiterals,
  VatTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  PaymentMethodWithLiterals,
  OrderTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  IssueReceiptApplicationErrors,
  CommonQueryWithEntityContext,
  PaymentLinkPaymentQuery,
  CommonSearchWithEntityContext,
  PaymentLinkPaymentSearch,
} from './paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';
